<template>
  <div id="subedit-popup">
    <div>
      <label class="lbl"> 
        Part# <input id="sub-part-no" v-on:keyup.enter="save"
                      v-model="subPartNoVal"/>
      </label>
    </div>
    <div>
      <label class="lbl"> 
        Qty <input id="sub-qty" v-on:keyup.enter="save"
                      v-model="subQtyVal"/>
      </label>
    </div>
    <div>
      <label class="lbl"> 
        Label <input id="sub-label" v-on:keyup.enter="save"
                     v-model="subLabelVal"/>
      </label>
    </div>
    <div>
      <label class="lbl"> 
        Bolt <input id="sub-bolt" v-on:keyup.enter="save"
                    v-model="subBoltVal"/>
      </label>
      <br>
      <label class="lbl"> 
        <input id="sub-washer" v-on:keyup.enter="save"
                    v-model="subWasherVal" type="checkbox"/>
        Washer 
      </label>
    </div>
    <div>
      <button @click="cancel" class=btn> 
        Cancel
      </button>
      <button @click="save" class=btn id="save"> 
        Save
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'sub-editor',

  data () {
    return {
      subPartNoVal:"",
      subQtyVal: "",
      subLabelVal: "",
      subBoltVal: "",
      subWasherVal: false,
      sub: [],
    }
  },
  props: [
    'subs',
    'selSubIdx',
    'newSubPart',
  ],

  methods: {
    save () {
      if(!this.subPartNoVal || !this.subQtyVal) {
        alert("Missing part# or qty");
        return;
      }
      this.sub.partNo =  this.subPartNoVal;
      this.sub.qty    = +this.subQtyVal;
      if(this.subWasherVal) this.sub.washer = true;
      else                  delete this.sub.washer
      if(this.subLabelVal) this.sub.label = this.subLabelVal;
      else delete this.sub.label;
      if(this.subBoltVal) this.sub.bolt = +this.subBoltVal;
      else delete this.sub.bolt;
      if(this.newSubPart) this.subs.push(this.sub);
      this.$parent.sortSubs();
      this.subPartNoVal = "";
      this.subQtyVal    = "";
      this.subLabelVal  = "";
      this.subBoltVal   = "";
      this.$parent.selSubIdx = this.sub.idx;

      this.$parent.dbUpdatePart(this.$parent.curPart);

      this.$parent.showSubEditor = false;
      this.$parent.showSubPartEditor = false;
      this.$parent.subClicked(this.sub.idx);
    },
    cancel () {
      this.subPartNoVal = "";
      this.subQtyVal    = "";
      this.subLabelVal  = "";
      this.subBoltVal   = "";
      this.$parent.showSubPartEditor = false;
    }
  },

  mounted () {
    this.sub = this.subs[this.selSubIdx];
    if(!this.sub && !this.newSubPart) {
      this.cancel();
      return;
    }
    if(this.newSubPart) this.sub = {partNo:"", qty: 1}
    this.subPartNoVal = this.sub.partNo;
    this.subQtyVal    = this.sub.qty;
    this.subLabelVal  = this.sub.label;
    this.subBoltVal   = this.sub.bolt;
    this.subWasherVal = this.sub.washer;
    document.getElementById('sub-part-no').focus();
  }
}
</script>

<style scoped>

#subedit-popup {
  position: absolute;
  left: 300px;
  top:  20px;
  border: 2px solid black;
  padding: 10px;
  background-color: lightgray;
  z-index: 2;
}

.lbl {
  font-weight: bold;
}
input {
    margin-top: 10px;
}
#sub-part-no {
  width: 60px;
}
#sub-descr {
  width: 300px;
}
.btn {
  color: white;
  background-color: blue;
  margin-top: 10px;
}
#save {
  float: right;
}

</style>
